import { render, staticRenderFns } from "./header-step-new.vue?vue&type=template&id=6a65f9dd&scoped=true"
import script from "./header-step-new.vue?vue&type=script&lang=ts"
export * from "./header-step-new.vue?vue&type=script&lang=ts"
import style0 from "./header-step-new.vue?vue&type=style&index=0&id=6a65f9dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a65f9dd",
  null
  
)

export default component.exports